/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

const form = {
  formId: "edit-event-form",
  formField: {
    name: {
      name: "name",
      label: "Event Title",
      type: "text",
      errorMsg: "Event title is required.",
    },
    start_date: {
      name: "start_date",
      label: "Start Date",
      type: "text",
      errorMsg: "Start Date is required.",
    },
    end_date: {
      name: "end_date",
      label: "End Date",
      type: "text",
      errorMsg: "End Date is required.",
    },
    description: {
      name: "description",
      label: "Description",
      type: "text",
      errorMsg: "Description is required.",
    },
    event_type: {
      name: "event_type",
      label: "Event Type",
      type: "number",
      errorMsg: "EventType is required.",
    },
    will_process: {
      name: "will_process",
      label: "Will Process",
      type: "boolean",
      errorMsg: "WillProcess is required.",
    },
    cover: {
      name: "cover",
      label: "cover",
      type: "file",
      errorMsg: "Cover image is required.",
    },
    address: {
      name: "address",
      label: "Address",
      type: "text",
      errorMsg: "Address is required.",
    },
    city: {
      name: "city",
      label: "City",
      type: "text",
      errorMsg: "City is required.",
    },
    state: {
      name: "state",
      label: "State",
      type: "text",
      errorMsg: "State is required.",
    },
    lat: {
      name: "lat",
      label: "Lat",
      type: "number",
      errorMsg: "Latitude is required.",
    },
    lon: {
      name: "lon",
      label: "Lon",
      type: "number",
      errorMsg: "Longitude is required.",
    },
    website: {
      name: "website",
      label: "Website",
      type: "text",
    },
    twitter: {
      name: "twitter",
      label: "Twitter Account",
      type: "text",
    },
    facebook: {
      name: "facebook",
      label: "Facebook Account",
      type: "text",
    },
    instagram: {
      name: "instagram",
      label: "Instagram Account",
      type: "text",
    },

  },
};

export default form;
